import { tokenKey } from '@/utils/helper'

export function lsSet(key, value) {
	// console.log(`${key} = ${JSON.stringify(value)}`)
	localStorage.setItem(tokenKey() + key, JSON.stringify(value))
}

export function lsGet(key, fallBack = null) {
	var s = localStorage.getItem(tokenKey() + key)
	
	return s ? JSON.parse(s) : fallBack
}

export function getRefer(){
	return lsGet("refer", "/")
}

export function setRefer(refer){
	return lsSet("refer", refer)
}